import { render, staticRenderFns } from "./GridDeDemonstracoes.vue?vue&type=template&id=7518c67a&"
import script from "./GridDeDemonstracoes.vue?vue&type=script&lang=ts&"
export * from "./GridDeDemonstracoes.vue?vue&type=script&lang=ts&"
import style0 from "./GridDeDemonstracoes.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports